import * as React from 'react';
import { SVGProps } from 'react';

const IconPlaySizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="m22.5 12-17 10V2l17 10Z" />
  </svg>
);
export default IconPlaySizeM;
